import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const HubSidebar = ({ activeTab, onTabChange, onDeleteTrip }) => {
    const menuItems = [
        { id: "overview", label: "Overview", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
        { id: "itinerary", label: "Itinerary", icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" },
        { id: "packing", label: "Packing List", icon: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" },
        { id: "tickets", label: "Tickets", icon: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" },
        { id: "stays", label: "Accommodation", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
        { id: "expenses", label: "Budget", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
        { id: "documents", label: "Documents", icon: "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9l-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" },
        { id: "share", label: "Share Trip", icon: "M18 8a3 3 0 10-2.83-4H15a3 3 0 100 6h.17A3 3 0 0018 8zM6 12a3 3 0 012.83 2H9a3 3 0 010-6h-.17A3 3 0 016 12zm9 4a3 3 0 00-2.83 2H12a3 3 0 100-6h.17A3 3 0 0015 16z" },
        { id: "invite", label: "Invite Friends", icon: "M17 20h5V4H2v16h5m10 0v-5m0 5l-5-5m5 5l5-5" },
        { id: "help", label: "Help", icon: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }
    ];

    return (
        <aside className="hidden lg:flex flex-col w-72 bg-white border-r border-gray-100 min-h-[calc(100vh-84px)] sticky top-[84px] shadow-[4px_0_24px_rgba(0,0,0,0.02)] z-20">
            <nav className="flex-1 p-6 space-y-1.5 overflow-y-auto scrollbar-hide">
                <p className="text-[10px] font-bold uppercase text-gray-400 tracking-widest px-4 mb-4">Command Center</p>
                {menuItems.map((item) => {
                    const isActive = activeTab === item.id;
                    return (
                        <button
                            key={item.id}
                            onClick={() => onTabChange(item.id)}
                            className={`relative w-full flex items-center gap-4 px-4 py-3 rounded-2xl font-bold transition-all duration-300 group ${isActive
                                ? "bg-[#5b6f00]/10 text-[#5b6f00]"
                                : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                                }`}
                        >
                            <div className={`relative flex items-center justify-center ${isActive ? "text-[#5b6f00]" : "text-gray-400 group-hover:text-gray-600"} transition-colors`}>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isActive ? "2.5" : "2"} d={item.icon} />
                                </svg>
                            </div>
                            <span className="text-sm tracking-tight">{item.label}</span>
                            <AnimatePresence>
                                {isActive && (
                                    <motion.div
                                        layoutId="sidebar-active"
                                        className="absolute left-[2px] w-1.5 h-6 bg-[#5b6f00] rounded-full"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                    />
                                )}
                            </AnimatePresence>
                        </button>
                    );
                })}
            </nav>

            <div className="p-6">
                <div className="bg-gradient-to-br from-[#5b6f00] to-[#455400] rounded-3xl p-6 text-white overflow-hidden relative group shadow-xl shadow-[#5b6f00]/20 mb-4">
                    <div className="absolute top-0 right-0 -mt-6 -mr-6 w-24 h-24 bg-white/10 rounded-full blur-xl transition-transform group-hover:scale-150 duration-700 pointer-events-none"></div>
                    <div className="relative z-10">
                        <div className="flex items-center gap-2 mb-3">
                            <span className="flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-white opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                            </span>
                            <p className="text-[10px] font-bold uppercase tracking-widest text-white/80">Pro Insight</p>
                        </div>
                        <p className="text-sm font-bold leading-tight mb-5">Keep track of items you need to pack before you go.</p>
                        <button
                            onClick={() => onTabChange('packing')}
                            className="w-full py-2.5 bg-white text-[#5b6f00] rounded-xl text-xs font-black shadow-lg shadow-black/10 hover:shadow-xl hover:-translate-y-0.5 active:scale-95 transition-all"
                        >
                            Check Now
                        </button>
                    </div>
                </div>

                <button
                    onClick={onDeleteTrip}
                    className="w-full flex items-center justify-center gap-2 text-red-500 border border-red-100 bg-red-50/50 px-4 py-3 rounded-2xl text-sm font-bold hover:bg-red-50 hover:border-red-200 hover:text-red-600 transition-all active:scale-95"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Delete Trip
                </button>
            </div>
        </aside>
    );
};

export default HubSidebar;
